import { BasicType } from "@easy-email-pro-core/constants";
import {
  ElementChildren,
  SocialItemElement,
} from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type SocialElementProps = RecursivePartial<
  SocialItemElement["attributes"]
> & {
  idx?: string | null;
  children?: ElementChildren | SocialItemElement["children"];
  data?: SocialItemElement["data"];
};

export function SocialElement(props: SocialElementProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: SocialItemElement = {
    type: BasicType.SOCIAL_ELEMENT,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
